import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { RatioOptions } from '@df/ui/atomic/atomic-options';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { defaultImage } from '../../icms.config';

export namespace NCmsImage {
    export const componentId = 'image';

    export interface IComponentData extends NICmsContentComponent.IData {
        image: string;
        ratio: string;
        link?: string;
    }
}

@ICmsComponent<CmsImageComponent>({
    id: NCmsImage.componentId,
    name: 'Image',
    tags: ['image', 'big', 'banner'],
    isAdvanced: true,
    fields: [
        {
            type: NICmsContentField.EFieldType.label,
            key: 'section-general',
            title: 'General'
        },
        <NICmsContentField.IChoiceField>{
            key: 'ratio',
            type: NICmsContentField.EFieldType.choice,
            title: 'Aspect ratio',
            options: RatioOptions,
            description: 'Proportions width x height',
            default: 'ratio-2-1',
            required: true
        },
        {
            key: 'image',
            type: NICmsContentField.EFieldType.image,
            title: 'Image',
            default: defaultImage,
            required: true
        },
        {
            key: 'link',
            type: NICmsContentField.EFieldType.text,
            title: 'Link'
        }
    ],
    priority: 30
})
@Component({
    selector: 'cms-image',
    templateUrl: './cms-image.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsImageComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component?: NCmsImage.IComponentData;
}
